
<mat-vertical-stepper [linear]="false" #stepper (selectionChange)="selectionChange($event,stepper)">
    <!-- feeding -->
    <mat-step *ngIf="ForceStepperControl.ForceFeeding" label="Feed">
        <ng-template matStepLabel>
            <div class="flex-align">
                <mat-icon style="margin-right: 10px; color: #10a810;" *ngIf="petFeedDone>0">check_circle</mat-icon>
                <mat-icon style="margin-right: 10px; color: red;" *ngIf="petFeedDone==0">priority_high</mat-icon>

                FEEDING INFORMATION REQUIRED
            </div>
        </ng-template>
        <div>
            <!-- table -->
            <div>
                <app-table [dataSource]="dataSource" [displayedColumns]="displayedColumns" [size]="size" [type]="'feed'"
                    #petFeed (petFeedDone)="petFeedCheck($event)" (stepperChange)="changeStepper()"> </app-table>
            </div>
        </div>
    </mat-step>
    <!-- Medication -->
    <mat-step *ngIf="ForceStepperControl.ForceMedication" label="Med">
        <ng-template matStepLabel>
            <div class="flexalign">
                <div>
                    <mat-icon style="margin-right: 10px; color: #10a810;" *ngIf="petMedDone>0">check_circle</mat-icon>
                    <mat-icon style="margin-right: 10px; color: red;" *ngIf="petMedDone==0">priority_high</mat-icon>
                </div>


                MEDICATION INFORMATION REQUIRED
            </div>
        </ng-template>

        <app-table [dataSource]="medication" [displayedColumns]="displayedColumns2" [type]="'med'"
            (petMedDone)="petMedCheck($event)" #petMed (stepperChange)="changeStepper()"></app-table>

    </mat-step>
     <!-- Questions -->
     <mat-step label="Questions" *ngIf="ForceQuestion">
        <ng-template matStepLabel>
            <div class="flex-align">
                <mat-icon style="margin-right: 10px; color: #10a810;" *ngIf="questionAnswered">check_circle</mat-icon>
                <mat-icon style="margin-right: 10px; color: red;" *ngIf="!questionAnswered">priority_high</mat-icon>
                Questions
            </div>
        </ng-template>
        <div>
            <div class="status" *ngIf="petsInfo">
                <ng-container *ngFor="let pet of petsInfo">
                    <div class="status-child" *ngIf="pet?.answers?.size > 0"
                        [ngClass]=" pet.name == currentPetName ? 'green_select' :'unselect' "
                        (click)="petSelectedForQuestion(pet.name)">
                        <mat-icon style="margin-right: 10px; color: #b1b3b1;">pets</mat-icon>
                        <span style="text-transform: uppercase; font-weight: 500;">{{pet.name}}</span>
                    </div>
                </ng-container>
            </div>
            <!-- Questions -->
            <div *ngFor="let entry of petQuestions | keyvalue">
                <h2 class="btn-header qheader">{{ entry.key }}</h2>
                <ng-container *ngFor="let question of entry.value,let i=index">
                    <p style="font-weight: 600; margin: 10px 0 10px !important;"> {{i+1}}.{{ question.fullQuestion }}*</p>
                    <textarea name="" id="" class="qtextarea" rows="3" [(ngModel)]="question.answer"  maxlength="1024"></textarea>
                </ng-container>
            </div>
            <div style="display: flex; justify-content: end; align-items: center;">
                <button mat-raised-button style="margin-right: 10px;"  (click)="ansNextPet(petQuestions)">Next</button>
            </div>

        </div>
    </mat-step>

    <mat-step *ngIf="showImmunization">
        <ng-template matStepLabel>
            <div class="flex-align">
                <!-- <mat-icon style="margin-right: 10px; color: red;">priority_high</mat-icon> -->
                <mat-icon *ngIf="!immunizationPassCheck"
                    style="margin-right: 10px; color: red;">priority_high</mat-icon>
                <mat-icon *ngIf="immunizationPassCheck"
                    style="margin-right: 10px; color: #10a810;">check_circle</mat-icon>

                IMMUNIZATION RECORDS
            </div>
        </ng-template>

        <!-- <div style="display: flex;flex-direction: column; align-items: center;">
            <h2 class="header-title">
                Scan to download the app
            </h2>

            <div *ngIf="qrCodeData?.appQRLink" style="margin-bottom: 16px;">
                <img [src]="qrCodeData.appQRLink" width="120px" />
            </div>

            <div>
                <a *ngIf="qrCodeData?.iosAppRateLink" target="_blank" [href]="qrCodeData?.iosAppRateLink">
                    <img src="assets/images/appStoreImg.png" />
                </a>

                <a *ngIf="qrCodeData?.androidAppRateLink" target="_blank" [href]="qrCodeData?.androidAppRateLink">
                    <img src="assets/images/googlePlayImg.png" />
                </a>
            </div>
        </div> -->

        <ng-container *ngFor="let immunization of immunizationsForPets">
            <ng-container *ngIf="showImmunizations(immunization.immunizations)">
                <h3 style="margin-bottom: 0px;">
                    {{ immunization.name }}
                </h3>

                <hr style="margin-bottom: 10px;margin-top: 10px;" />

                <table mat-table [dataSource]="immunization.immunizations" class="mat-elevation-z8" style="width:100%">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.petImmunizationTypeName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="expiry date">
                        <th mat-header-cell *matHeaderCellDef style="width:20%;"> Expiry Date </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.endDate">
                                <span>{{ formatDate(element.endDate, 'MM/dd/yyyy')}}</span>
                            </ng-container>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef style="width:20%;"> Status </th>
                        <td mat-cell *matCellDef="let element"> {{element.status}} </td>
                    </ng-container>

                    <ng-container matColumnDef="service">
                        <th mat-header-cell *matHeaderCellDef style="width:20%;"> Service </th>
                        <td mat-cell *matCellDef="let element"> {{element.reservationName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-button style="background-color: #41A049;color:white"
                                (click)="showAddImmunizationDialog(immunization)"> Add</button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsForImmunizations"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsForImmunizations;"></tr>
                </table>

                <div style="margin-bottom:20px "></div>
            </ng-container>
        </ng-container>
    </mat-step>

    <mat-step *ngIf="showAgreementForSign">
        <ng-template matStepLabel>
            <div class="flex-align">
                <mat-icon *ngIf="!agreementPassCheck" style="margin-right: 10px; color: red;">priority_high</mat-icon>
                <mat-icon *ngIf="agreementPassCheck" style="margin-right: 10px; color: #10a810;">check_circle</mat-icon>
                AGREEMENT
            </div>
        </ng-template>
        <ng-container *ngIf="petOwnersAgreements.length > 0">
            <h3 style="margin-bottom: 0px;">
                <span *ngIf="appService.userName && appService.userName != ''">{{appService.userName}}</span><span *ngIf="!appService.userName || appService.userName == ''">Pet Owner Agreements</span>
            </h3>
            <hr style="margin-bottom: 10px;margin-top: 10px;" />
            <table mat-table [dataSource]="petOwnersAgreements" class="mat-elevation-z8" style="width:100%">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                        {{element.name}} </td>
                </ng-container>

                <ng-container matColumnDef="signed date">
                    <th mat-header-cell *matHeaderCellDef style="width:20%;"> Signed Date </th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                        <ng-container *ngIf="element.signedDate">
                            <span>{{ formatDate(element.signedDate, 'MM/dd/yyyy')}}</span>
                            <span style="margin-left:5px;">{{ formatDate(element.signatureTime, 'hh:mm a')}}</span>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="expiration date">
                    <th mat-header-cell *matHeaderCellDef style="width:20%;"> Expiration Date </th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                        <ng-container *ngIf="element.expirationDate">
                            <span>{{ formatDate(element.expirationDate, 'MM/dd/yyyy hh:mm a')}}</span>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                        {{element.status}} </td>
                </ng-container>


                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action <br> (click below to sign)</th>
                    <td mat-cell *matCellDef="let element"  style="text-align: center;"
                        [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                        <img src="assets/images/signature.svg"
                            style="height: 30px;width:30px;margin-left:5px;cursor:pointer"
                            (click)="showAgreement(element)" />
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsForAgreements"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsForAgreements;"></tr>
            </table>
        </ng-container>
        <ng-container *ngFor="let agreement of agreements">
            <ng-container *ngIf="showAgreements(agreement.agreements)">
                <h3 style="margin-bottom: 0px;">
                    {{ agreement.name }}
                </h3>

                <hr style="margin-bottom: 10px;margin-top: 10px;" />

                <table mat-table [dataSource]="agreement.agreements" class="mat-elevation-z8" style="width:100%">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                            {{element.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="signed date">
                        <th mat-header-cell *matHeaderCellDef style="width:20%;"> Signed Date </th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                            <ng-container *ngIf="element.signedDate">
                                <span>{{ formatDate(element.signedDate, 'MM/dd/yyyy')}}</span>
                                <span style="margin-left:5px;">{{ formatDate(element.signatureTime, 'hh:mm a')}}</span>
                            </ng-container>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="expiration date">
                        <th mat-header-cell *matHeaderCellDef style="width:20%;"> Expiration Date </th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                            <ng-container *ngIf="element.expirationDate">
                                <span>{{ formatDate(element.expirationDate, 'MM/dd/yyyy hh:mm a')}}</span>
                            </ng-container>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element"
                            [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                            {{element.status}} </td>
                    </ng-container>


                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action <br> (click below to sign)</th>
                        <td mat-cell *matCellDef="let element"  style="text-align: center;"
                            [ngClass]="{'force-agreement-color' : (element.forceAgreement && element.status != 'SIGNED')}">
                            <img src="assets/images/signature.svg"
                                style="height: 30px;width:30px;margin-left:5px;cursor:pointer"
                                (click)="showAgreement(element)" />
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsForAgreements"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsForAgreements;"></tr>
                </table>

                <div style="margin-bottom:20px "></div>
            </ng-container>
        </ng-container>
    </mat-step>

    <!-- Cod -->
    <mat-step *ngIf="ForceStepperControl.ForceCardOnFile" label="Cof">
        <ng-template matStepLabel>
            <div class="flexalign">
                <mat-icon style="margin-right: 10px; color: #10a810;" *ngIf="cardDone>0">check_circle</mat-icon>
                <mat-icon style="margin-right: 10px; color: red;" *ngIf="cardDone==0">priority_high</mat-icon>

                CARD ON FILE REQUIRED
            </div>
        </ng-template>

        <div class="button">
            <button mat-raised-button (click)="OpenAddCardDialog()" style="background-color: #41A049;
            color: #eee;">Add Card</button>
        </div>

        <div>
            <app-table [type]="'card'" #ownerCard (cardFeedDone)="cardCheck($event)"></app-table>
        </div>

    </mat-step>
   

</mat-vertical-stepper>